import React from "react";
import { Card, Row, Col, CardImg, CardText } from "reactstrap";
import "./card-item.scss";
function shorText(cad) {
  if (cad != null) {
    if (cad.length > 170) {
      return cad.substring(0, 170) + " ...";
    }
  }
  return cad;
}
function CardItem(props) {
  if (props.items.length > 0) {
    return (
      <Row className="no-gutters ">
        {props.items.map((item, index) => (
          <Col key={index} xs={12} sm={12} md={4} xl={4} className="block-height">
            <Card  className=" mt-3">
              <Row className="no-gutters mb-2">
                <Col xs={5} sm={5} md={5} xl={5} className="card-item-max"
                >
                  <CardImg
                    className="img-thumbnail h-100"
                    src={`${item.url_caratula}`}
                    alt="Portada"
                  />
                </Col>
                <Col xs={7} sm={7} md={7} xl={7}>
                  <div className="ml-2">
                    <div>
                      <span>
                        <a
                          href={`${item.url_sinia}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={item.nombre}
                        >
                          <p className="block-text-title font-weight-bold">
                            {shorText(item.nombre)}
                          </p>
                        </a>
                      </span>
                    </div>
                    <div>
                      <span className="card-item-tipo">{item.tipo}</span>
                    </div>
                    <div>
                      <CardText className="mt-2">
                        {" "}
                        <a
                          href={`${item.url_sinia}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-primary btn-sm"
                        >
                          Leer más
                        </a>
                      </CardText>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    );
  } else {
    return <div></div>;
  }
}

export default CardItem;
